import api from './api';

const lbsContactWayService = {
  // LBS活码管理
  getLbsContactWays: (params = {}) => {
    return api.get('/lbs-contact-ways', { params });
  },

  getLbsContactWay: (id) => {
    return api.get(`/lbs-contact-ways/${id}`);
  },

  createLbsContactWay: (data) => {
    return api.post('/lbs-contact-ways', data);
  },

  updateLbsContactWay: (id, data) => {
    return api.put(`/lbs-contact-ways/${id}`, data);
  },

  deleteLbsContactWay: (id) => {
    return api.delete(`/lbs-contact-ways/${id}`);
  },
  
  // LBS活码编辑
  getLbsContactWayEditDetails: (id) => {
    return api.get(`/lbs-contact-ways/${id}/edit-details`);
  },

  // LBS活码关联管理
  getLbsContactWayRelations: (lbsContactWayId) => {
    return api.get(`/lbs-contact-ways/${lbsContactWayId}/relations`);
  },

  addLbsContactWayRelation: (lbsContactWayId, data) => {
    return api.post(`/lbs-contact-ways/${lbsContactWayId}/relations`, data);
  },

  deleteLbsContactWayRelation: (relationId) => {
    return api.delete(`/lbs-contact-ways/relations/${relationId}`);
  },

  // LBS匹配
  findBestContactWayByLbs: (lbsContactWayId, longitude, latitude) => {
    return api.get(`/lbs-contact-ways/${lbsContactWayId}/best-contact-way`, {
      params: { longitude, latitude }
    });
  },

  // 地理位置相关API
  findNearestContactWay: (longitude, latitude) => {
    return api.get('/lbs-contact-ways/nearest', {
      params: { lng: longitude, lat: latitude }
    });
  },

  updateRelationCoordinates: (relationId, coordinates) => {
    return api.put(`/lbs-contact-ways/relations/${relationId}/coordinates`, coordinates);
  },

  findRelationsByDistance: (longitude, latitude, limit = 10) => {
    return api.get('/lbs-contact-ways/relations/by-distance', {
      params: { lng: longitude, lat: latitude, limit }
    });
  },

  // 海报管理
  updateLbsContactWayPoster: (id, data) => {
    return api.put(`/lbs-contact-ways/${id}/poster`, data);
  },

  removeLbsContactWayPoster: (id) => {
    return api.delete(`/lbs-contact-ways/${id}/poster`);
  }
};

export default lbsContactWayService;